/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { connect } from "react-redux";
import { CollectionLayout } from "./section";
import get from "lodash/get";

const CollectionPageBase = props => {
  const {
    darkBgColor,
    bgColor,
    enableIntroCard = false
  } = get(props, ["config", "pagebuilder-config", "section", "pageSetting"], {});
  const style = (props.enableDarkMode ? darkBgColor : bgColor) || bgColor;
  const collectionName = get(props, ["data", "collection", "name"], "");
  return (
    <div style={{ backgroundColor: style || "initial" }}>
      {/* H1 is not required visually but need for SEO */}
      {!enableIntroCard && <h1 style={{ display: "none" }}>{collectionName}</h1>}
      <CollectionLayout {...props} />
    </div>
  );
};

function mapStateToProps (state) {
  return {
    config: state.qt.config,
    enableDarkMode: get(state, ["header", "isDarkModeEnabled"], false)
  };
}

export const CollectionPage = connect(mapStateToProps)(CollectionPageBase);
